import { useState } from 'react';
import { stills } from '@/mocks/russianMom';

export default function StillsSection() {
  const [active, setActive] = useState<number | null>(null);

  return (
    <section id="stills" className="w-full bg-background-950 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-3 py-1 text-xs font-medium text-accent-300">
              <i className="ri-image-2-line" aria-hidden="true"></i>
              精彩剧照
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-background-50 md:text-3xl">
              画面随四季流转，冷暖都在镜头里
            </h2>
            <p className="mt-3 text-sm leading-7 text-background-300">
              剧中的场景多以生活实景为主，色调随季节变化。点击任意一张可以放大查看。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {stills.map((s, i) => (
            <button
              key={s.id}
              type="button"
              onClick={() => setActive(i)}
              aria-label={`放大查看：${s.alt}`}
              className="group relative block h-[200px] w-full overflow-hidden rounded-lg border border-background-50/10 md:h-[220px]"
            >
              <img
                src={s.img}
                alt={s.alt}
                className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent"></span>
              <span className="absolute bottom-3 left-3 right-3 flex items-center gap-2 text-left text-xs text-background-100">
                <i className="ri-zoom-in-line text-accent-300" aria-hidden="true"></i>
                {s.alt}
              </span>
            </button>
          ))}
        </div>
      </div>

      {active !== null && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-foreground-950/90 p-4"
          role="dialog"
          aria-modal="true"
          aria-label="剧照预览"
          onClick={() => setActive(null)}
        >
          <div className="relative w-full max-w-4xl" onClick={(e) => e.stopPropagation()}>
            <img
              src={stills[active].img}
              alt={stills[active].alt}
              className="max-h-[80vh] w-full rounded-lg object-contain"
            />
            <p className="mt-3 text-center text-sm text-background-200">{stills[active].alt}</p>
            <button
              type="button"
              onClick={() => setActive(null)}
              aria-label="关闭预览"
              className="absolute -top-3 right-0 flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-950 transition-colors hover:bg-background-200"
            >
              <i className="ri-close-line text-lg" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      )}
    </section>
  );
}